import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { PoweredBy } from "../Workspace/PoweredBy";
import { ThemeDictionary } from "client/Api/Branding/branding";
import styles from "./PublicPagePoweredBy.module.less";
import { ensureNotNil } from "client/Misc/utils";

export type PublicPagePoweredByProps = {
	isPoweredByTextEnabled: boolean;
	logoUrls: ThemeDictionary<string>;
};

export const PublicPagePoweredBy = (props: PublicPagePoweredByProps): ReactElement => {
	const {
		isPoweredByTextEnabled,
		logoUrls
	} = props;

	return (
		<div className={styles.root}>
			<PoweredBy
				isPoweredByTextEnabled={isPoweredByTextEnabled}
				logoUrls={logoUrls}
				textColor="tertiary"
			/>
		</div>
	);
};
PublicPagePoweredBy.displayName = "PublicPagePoweredBy";

export function init(props: PublicPagePoweredByProps): void {
	createRoot(
		ensureNotNil(
			document.getElementById("public-page-powered-by-host")
		)
	)
		.render(
			<PublicPagePoweredBy {...props} />
		);
}
